/* eslint-disable no-unused-vars */
import { action } from 'typesafe-actions';
import { ActionCreator, Action } from 'redux';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';

import { makeGetFile } from 'services';
import { types } from './configuration.types';
import { ICustomerConfigurations } from './configuration';

const storeCustomerConfigurations: ActionCreator<Action<string>> = (payload: ICustomerConfigurations) =>
  action(types.STORE_CUSTOMER_CONFIGURATIONS, payload);

const getCustomerConfigurationLogoSuccessful: ActionCreator<Action<string>> = (payload: string) =>
  action(types.GET_CURRENT_CUSTOMER_LOGO_SUCCESS, payload);

const getCustomerConfigurationLogoFailed: ActionCreator<Action<string>> = (payload: string) =>
  action(types.GET_CURRENT_CUSTOMER_LOGO_FAILURE, payload);

const getCustomerConfigurationLogo = (isDarkTheme: boolean) => (dispatch: (arg0: Action<string>) => void) => {
  dispatch(action(types.GET_CURRENT_CUSTOMER_LOGO_STARTED));
  makeGetFile(`customerConfigurations/current/custom-logo?theme=${isDarkTheme ? '1' : '0'}`).subscribe(
    ({ response }: AjaxResponse<any>) => {
      let logoUrl = null;

      if (response?.size) {
        logoUrl = window.URL.createObjectURL(response);
      }

      dispatch(getCustomerConfigurationLogoSuccessful(logoUrl));
    },
    (error: AjaxError) => {
      const response = error?.response;
      dispatch(getCustomerConfigurationLogoFailed(response?.error || 'An error occurred'));
    }
  );
};

const setCameraAccessDenied = (payload:boolean) => action(types.SET_CAMERA_ACCESS_DENIED_SUCCESS, payload);

const setGeolocationAccessNeeded = (payload:boolean) => action(types.SET_GEOLOCATION_ACCESS_NEEDED_SUCCESS, payload);
const setGeolocationEnabled = (payload:boolean) => action(types.SET_GEOLOCATION_ENABLED_SUCCESS, payload);

const setServiceUnavailable = (payload:boolean) => action(types.SET_SERVICE_UNAVAILABLE_SUCCESS, payload);

export {
  storeCustomerConfigurations,
  getCustomerConfigurationLogo,
  setCameraAccessDenied,
  setGeolocationAccessNeeded,
  setServiceUnavailable,
  setGeolocationEnabled
};
